import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next'; 

import React, { Component } from 'react'

import { getApiDatas, postApiDatas, getStorageItem } from "../utilities/FrontFunctions/AoxFrontFunctions"
import { trackGA4Event } from '../utilities/FrontFunctions/AoxTrackingFunctions'

import ObjParcoursPersoHomeComptoirDermato from './inc/ObjParcoursPersoHomeComptoirDermato'
import ObjContinuerLectureHomeComptoirDermato from './inc/ObjContinuerLectureHomeComptoirDermato'
import ModalFormationsFav from "./inc/Modal/ModalFormationsFav"

import '../assets/css/0020_objects/0880_obj_intro_home_comptoir_dermato.css'
import '../assets/css/0020_objects/0890_obj_tabs_home_comptoir_dermato.css'

class PageBrandAv_Formations extends Component {
    constructor(props) {
		super(props)
		this.state = {
		}
		this.handleButtonFav = this.handleButtonFav.bind(this)
	}

    componentDidMount() {
        const { scDatas } = this.props.fields.data;

        let params = `sBrandCode=${scDatas.codeAbbrege?.value}`;
        const datasScParcours1 = scDatas.ListParcoursFolder[0]?.ListParcours[0];
        if(datasScParcours1){
            params += "&sParcours1Id=" + datasScParcours1.id;
        }

        getApiDatas(`/apiaox/Call/PageBrandAv?${params}`).then((apiDatas) => { 
            this.setState({ apiDatas:apiDatas })
            window.scrollTo(0,0)
        })
    }

    handleButtonFav(id) {
        //pushs possibles sur parcours et continuer
        var datasTraining = this.state.apiDatas.Parcours1.Formations.find(t => t.Training_ItemTraining_Id === id);
        if(!datasTraining){ datasTraining = this.state.apiDatas.TrainingsInProgress.find(t => t.Training_ItemTraining_Id === id); }
        if(datasTraining){
            if(!datasTraining.Training_IsFavorite){
                //ajouter favori
                document.body.classList.add('is-loading')
                trackGA4Event(window.trackDatas, "training_add_favorite", "training", "training add favorite", "star icon");
                postApiDatas(`/apiaox/Call/AddTrainingFavorite?sIdTraining=${id}`, {})
                .then((res) => {
                    document.body.classList.remove('is-loading')
                    if (!res.IsValid) { alert(res.Message) }
                    else {
                        let newDatas = this.state.apiDatas;

                        //switcher le statut sur les 2 listes
                        newDatas.Parcours1.Formations.forEach(t => {if(t.Training_ItemTraining_Id === id){t.Training_IsFavorite = true}});
                        newDatas.TrainingsInProgress.forEach(t => {if(t.Training_ItemTraining_Id === id){t.Training_IsFavorite = true}});

                        this.setState({ apiDatas: newDatas })
                        
                        if(!getStorageItem('dontShowAgainModalMAJFormationsFav')){
                            this.ModalFormationsFav.openModal();
                        }
                    }
                });
            } else {
                //supprimer favori
                document.body.classList.add('is-loading')
                postApiDatas(`/apiaox/Call/RemoveTrainingFavorite?sIdTraining=${id}`, {})
                .then((res) => {
                    document.body.classList.remove('is-loading')
                    if (!res.IsValid) { alert(res.Message) }
                    else {
                        let newDatas = this.state.apiDatas;

                        //switcher le statut sur les 2 listes
                        newDatas.Parcours1.Formations.forEach(t => {if(t.Training_ItemTraining_Id === id){t.Training_IsFavorite = false}});
                        newDatas.TrainingsInProgress.forEach(t => {if(t.Training_ItemTraining_Id === id){t.Training_IsFavorite = false}});

                        this.setState({ apiDatas: newDatas })
                    }
                });
            }
        }
    }

	render() {
        const { scDatas } = this.props.fields.data;
        const { apiDatas } = this.state;

        return (<>{scDatas && apiDatas && <>
			<section className="obj_section section_content_formation section_comptoir_dermato">
				<div className="ctn_section">

					<div className="ctn_row">
                        {apiDatas.Parcours1 && 
                            <ObjParcoursPersoHomeComptoirDermato datasParcour={apiDatas.Parcours1} handleButtonFav={this.handleButtonFav}/>
                        }

                        {apiDatas.TrainingsInProgress && (apiDatas.TrainingsInProgress.length > 0) && 
                            <ObjContinuerLectureHomeComptoirDermato datasTrainings={apiDatas.TrainingsInProgress} handleButtonFav={this.handleButtonFav}/>
                        }
					</div>

				</div>
			</section>

            <ModalFormationsFav 
                onRef={ref => (this.ModalFormationsFav = ref)} 
                modalTitle=""
                modalText="Vous venez d'ajouter cette formation à votre liste de favoris"
                modalCtaText="Retrouver mes favoris"
            />
        </>}</>)
	}
}

export default withTranslation()(withSitecoreContext()(PageBrandAv_Formations));